module.exports = require('./helpers/bundle-url').getBundleURL('3ufsE') + "marker-shadow.8f26ed1f.png";